import store from '@/state/store';
import { list } from '@/api/project';
import { handleError } from '@/actions/common';
import projectSlice from '@/state/project.slice';
import { RequestStatus } from '@/contracts';

export default async function (): Promise<void> {
  const { projects } = store.getState();
  if (projects.listFetchStatus === RequestStatus.BUSY) return;
  try {
    store.dispatch(projectSlice.actions.listFetching());
    const l = await list();
    store.dispatch(projectSlice.actions.listFetched(l));
  } catch (error) {
    store.dispatch(projectSlice.actions.listFetched([]));
    handleError(error);
  }
};